const scrollToAnchorLinkAfterGoingToNewPage = (offset = 100) => {
    setTimeout(() => {
        const { hash } = window.location;
        if (hash && hash.startsWith('#')) {
            const anchorName = hash.slice(1);
            const targetElement = document.getElementById(anchorName);
            if (targetElement) {
                window.scrollTo({
                    top: targetElement.offsetTop - offset,
                    behavior: 'smooth',
                });
            }
        }
    }, 500);
};
export default scrollToAnchorLinkAfterGoingToNewPage;
